var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderAge18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 458",
    style: {
      enableBackground: "new 0 0 510 458"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#809595;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.4,373c-79.1,0-143.5-64.4-143.5-143.5S174.3,86,253.4,86s143.5,64.4,143.5,143.5S332.6,373,253.4,373z  M253.4,99.7c-71.6,0-129.8,58.2-129.8,129.8s58.2,129.8,129.8,129.8s129.8-58.2,129.8-129.8S325,99.7,253.4,99.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.8,185c13.5,0,20.9-4.9,22.4-17.1h18.3v133.1h-18.3V193.3c-6.1,5.3-12.7,6.8-25.5,6.8V185H179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.8,261c0-15.2,8.6-27.4,20-33.7c-8.7-6.5-13.9-16.7-13.9-27.6c0-19.8,16.9-33.8,38-33.8s38,14.1,38,33.8 c0,10.8-5.1,21.1-13.9,27.6c11.4,6.3,20,18.4,20,33.7c0,23.8-16.7,41.8-44.1,41.8C256.6,302.8,239.8,284.8,239.8,261z M283.9,286.1 c13.9,0,25.5-10.1,25.5-25.5c0-15.4-11.6-25.5-25.5-25.5c-13.9,0-25.5,10.1-25.5,25.5C258.5,276,270.1,286.1,283.9,286.1z  M283.9,220.7c12,0,20.5-8,20.5-20c0-12-8.6-20-20.5-20s-20.5,8-20.5,20C263.4,212.7,272,220.7,283.9,220.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderAge18);
export default __webpack_public_path__ + "static/media/UnderAge18.7c57158d6f37b6d13afa8f2267467c59.svg";
export { ForwardRef as ReactComponent };